import { makePreloadSlot } from '../UnicronApp/preloader/PreloadSlot';

export const noAnalyticsSlot = makePreloadSlot('DISABLE_ANALYTICS', false);
